/**
 * XProfilePage · P6-Merge
 *
 * Die früher eigenständige /x-Identität ist abgeschafft — es gibt nur EIN
 * stilltouchedX-Profil (die bestehende Seller-Profilseite, adressiert über den
 * stx_handle). /x/:handle leitet daher dauerhaft auf /user/:handle/stx um.
 */
import { Navigate, useParams } from "react-router-dom";

export default function XProfilePage() {
  const { handle } = useParams();
  return <Navigate to={`/user/${handle}/stx`} replace />;
}
